import React, { ChangeEvent, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import {
  createNewSite,
//  editSiteSn,
  addSiteConcentrateurs,  //Contacts
  selectSitesState,
  clearSubmitSiteError,
} from '../../redux/slices/sitesSlice';
//import { selectUsersState } from '../../redux/slices/usersSlice';
import { selectContactsState } from '../../redux/slices/contactsSlice';
import { Concentrateur, ConcentrateurPayload, ConcentrateurState, Contact, SiteState } from '../../redux/types';
import ErrorBox from '../../components/ErrorBox';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  TextField,
  Button,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Chip,
  InputAdornment,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  IconButton,
  DialogContent,
  DialogTitle,
  Paper,
  InputLabel,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  TableHead,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useFormStyles, useMainPageStyles, useTableStyles } from '../../styles/muiStyles';
import LabelImportantIcon from '@material-ui/icons/LabelImportant';
import StorageIcon from '@material-ui/icons/Storage';
import SubjectIcon from '@material-ui/icons/Subject';
import AlertIcon from '@material-ui/icons/ReportProblemOutlined';
import Stopped from '@material-ui/icons/BlockOutlined';
import { formatDate } from '../../utils/helperFuncs';
import { Label } from '@material-ui/icons';
import classes from '*.module.css';
import { current } from '@reduxjs/toolkit';
import { AddConcentrateur, editConcentrateur } from '../../redux/slices/concentrateursSlice';
import { RootState } from '../../redux/store';
import NoteForm from './NoteForm';
import { format } from 'date-fns';

const validationSchema = yup.object({
  //name: yup
  siteId: yup
    .string()
    .required('Required')
    .max(60, 'Must be at most 60 characters'),
});

const CarnetDeBord: React.FC<{
  editMode: 'EditNote',
  siteId: string,
  siteSn: string,
  closeDialog?: () => void;
}> = ({
  closeDialog,
  editMode,
//  currentSites,
  siteId,
  siteSn,
}) => {
  const classes = useMainPageStyles();
  const classes2 = useTableStyles();
  const dispatch = useDispatch();
  const { submitError, submitLoading } = useSelector(selectSitesState);
  const isMobile = false //temporaire
  const sites = useSelector((state: RootState) =>
    selectSitesState(state)
  );
  console.log("SN site: "+siteSn)
  console.log("Nb sites: "+sites?.sites.filter((s)=>Number(s.sn_site) === Number(siteSn)).length)
  sites?.sites.filter((s)=>Number(s.sn_site) === Number(siteSn)).map((n) => {
    console.log("Date UPDATE: ["+n.date_update+"]")
  });
  sites?.sites.filter((s)=>Number(s.sn_site+2) === Number(siteSn+2)).map((n) => {
    console.log("Date UPDATE N+2: ["+n.date_update+"]")
  });

  return (
    <Paper/* className={classes.root}*/>
      <NoteForm key="_note" isEditMode={false} siteId={siteId} currentBody={''} contactId={sites?.sites.find(s => s.id === siteId)?.contacts[0].id} date={format(new Date(Date.now()), "yyyy-MM-dd'T'h':'mm")/*format(new Date(Date.now()), "yyyy-MM-dd'T'h':'mm")*/} /*date={''}*/ />
      { sites?.sites.filter((s)=>Number(s.sn_site) === Number(siteSn)).sort((a,b) => +new Date(b.date_update) - +new Date(a.date_update)).map((n,index) => (
          n.date_update === null ?
            <NoteForm key={n.id+"_note_"+index} isEditMode={true} date={""/*"0NaN-NaN-NaNTNaN:NaN:NaN.NaN+NaN:NaN"*/} siteId={n.id} contactId={sites?.sites.find(s => s.id === siteId)?.contacts[0].id} currentBody={n.rq_instru} />
//                : <NoteForm key={n.id+"_note"} isEditMode={true} date={format(new Date(Date.now()), "yyyy-MM-dd'T'h':'mm")/*format(new Date(Date.now()), "yyyy-MM-dd'T'h':'mm")*/} siteId={n.id} currentBody={n.rq_instru} />
              : <NoteForm key={n.id+"_note_"+index} isEditMode={true} contactId={sites?.sites.find(s => s.id === siteId)?.contacts[0].id} date={
                n.date_update /*!== undefined*/ ? format(new Date(n.date_update || new Date(Date.now())), "yyyy-MM-dd'T'h':'mm") : "1970-01-01T1:00"
            } siteId={n.id} currentBody={n.rq_instru} />
      ))}
    </Paper>
    );
};
//        <NoteForm key="_note" isEditMode={false} siteId={siteId} currentBody={''} date={new Date(Date.now())/*format(new Date(Date.now()), "yyyy-MM-dd'T'h':'mm")*/} /*date={''}*/ />
export default CarnetDeBord;
